import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { schoolfeesincrease } from './schoolfeesincrease.service';
import { global } from '../../../shared/global';
import { FeesIncrease } from '../../Models/feesincrease.model';
declare var $: any;

@Component({
  selector: 'app-schoolfeesincrease',
  templateUrl: './schoolfeesincrease.component.html',
  styleUrls: ['./schoolfeesincrease.component.css']
})
export class SchoolfeesincreaseComponent implements OnInit {
  @ViewChild('feesIncreaseForm') feesIncreaseForm: NgForm;
  p: number = 1;
  responseData: any;
  feesIncreaselist: Array<any> = [];
  pageLimit = global.pageLimit;
  searchtext;
  reverseSort = false;
  dataTable: any;
  isDesc: boolean;
  column: string;
  data: FeesIncrease;
  dropDownData: any;
  mediums: any;
  stds: any;
  userList1;
  lastkeydown1: any = 0;
  years: any;
  courseyears: any;
  submitted: boolean = false;
  totalFeesAmount: number = 0;
  NewtotalFeesAmount: any = 0;
  btnsubmittext:any = "Submit"

  constructor(private service: schoolfeesincrease, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;
    }
    this.data = new FeesIncrease();
    this.fillMedium();
    this.fillStd();
    this.fillAcademicYear();
    // this.getSchoolFeesIncreaseList();
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.data.HashCode = this.rout.snapshot.paramMap.get('ID');
      setTimeout(() => { this.fillFeesIncreaseDetail(); }, 1000);
      this.btnsubmittext = "Update";
    }
  }

  fillMedium() {
    const data = {
      HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.data.MediumID = 0;
      });
  }

  fillStd() {
    const data = {
      HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.stds = this.dropDownData.dropdownlist;
        this.data.CourseID = 0;
        this.data.CourseYearID = 0
      });
  }

  fillAcademicYear() {
    const data = {
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.data.AcademicYearID = this.years[0]["value"];
      });
  }

  fillCourseYear(id) {
    if (this.data.CourseID != undefined && this.data.CourseID > 0) {
      for (var i = 0; i < this.stds.length; i++) {
        if (this.stds[i]["value"] == this.data.CourseID) {
          this.courseyears = [];
          for (var j = 1; j <= this.stds[i]["noofyear"]; j++) {
            var yeartext = this.displayyear(j);
            this.courseyears[this.courseyears.length] = { "id": 1, "text": yeartext, "value": j }
          }
        }
      }
    }
    this.data.CourseYearID = id
  }

  displayyear(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  showDetail() {
    this.submitted = false;
    this.data.YearID = parseInt(localStorage.getItem("yearID"));
    if (this.data.AcademicYearID == undefined || this.data.AcademicYearID == 0 || this.data.MediumID == undefined || this.data.MediumID == 0
      || this.data.CourseID == undefined || this.data.CourseID == 0 || this.data.CourseYearID == undefined || this.data.CourseYearID == 0) {
      this.submitted = true;
      return
    }
    this.service.getFeesIncreaseDetail(this.data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.feesIncreaselist = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.feesIncreaselist = this.responseData["feesIncreaseHeadWises"];
          for (var i = 0; i < this.feesIncreaselist.length; i++) {
            this.totalFeesAmount += this.feesIncreaselist[i]["FeesAmountActual"]
            this.NewtotalFeesAmount += this.feesIncreaselist[i]["FeesAmount"]
          }
          this.disableCtrl(true);
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  calculateTotal() {
    this.NewtotalFeesAmount = 0;
    for (var i = 0; i < this.feesIncreaselist.length; i++) {
      if ($("#newAmt" + i).val() == "")
        $("#newAmt" + i).val('0')
      this.NewtotalFeesAmount += parseFloat($("#newAmt" + i).val());
    }
    this.NewtotalFeesAmount = this.NewtotalFeesAmount.toFixed(2);
  }

  disableCtrl(flag) {
    if (flag) {
      $("#AcademicYearID").prop("disabled", "disabled");
      $("#MediumID").prop("disabled", "disabled");
      $("#CourseID").prop("disabled", "disabled");
      $("#CourseYearID").prop("disabled", "disabled");
      $("#btnShow").hide();
      $("#btnReset").show();
    } else {
      $("#AcademicYearID").prop("disabled", false);
      $("#MediumID").prop("disabled", false);
      $("#CourseID").prop("disabled", false);
      $("#CourseYearID").prop("disabled", false);
      $("#btnShow").show();
      $("#btnReset").hide();
      this.feesIncreaselist = [];
    }
  }

  resetForm() {
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.MediumID = 0;
    this.data.CourseID = 0;
    this.data.CourseYearID = 0;
    this.data.AcademicYearID = parseInt(this.years[0]["value"]);
    this.submitted = false;
    this.disableCtrl(false);
  }

  fillFeesIncreaseDetail() {
    this.spinner.show();
    const data = {
      HashCode: this.data.HashCode
    };
    this.service.fillSchoolFeesIncreaseDetail(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.feesIncreaselist = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return;
        }
        else {
          this.spinner.show();
          this.data = this.responseData;
          this.fillCourseYear(this.responseData["CourseYearID"]);
          this.feesIncreaselist = this.responseData.feesIncreaseList;
          this.NewtotalFeesAmount = this.responseData["TotalFeesAmount"];
          this.totalFeesAmount = this.responseData["TotalFeesAmountActual"];
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  addNewRequest() {
    if (this.feesIncreaselist.length == 0) {
      this.toastr.error("Add new request detail");
      return;
    }

    if (this.NewtotalFeesAmount == "" || this.NewtotalFeesAmount == undefined || this.NewtotalFeesAmount <= 0) {
      this.toastr.error("Add fees amount to request");
      return
    }

    for(var i=0;i < this.feesIncreaselist.length; i++){
      this.feesIncreaselist[i]["FeesAmount"] = parseFloat($("#newAmt" + i).val());
    }

    this.data.feesIncreaseList = this.feesIncreaselist;
    this.data.TotalFeesAmount = this.NewtotalFeesAmount;
    this.data.YearID = parseInt(localStorage.getItem("yearID"));

    this.spinner.show();
    this.service.saveSchoolFeesIncrease(this.data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.toastr.success(this.responseData.message);
          this.router.navigate(['/schoolfeesincreaserequestlist']);
          this.resetForm();
          this.feesIncreaselist = [];
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }

  onlyDouble(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    // if (charCode == 46 ) // && val != undefined && String(val).includes('.')
    //   return false;
    // var i = String(val).indexOf('.');
    // if (i > 0 && String(val).length > i + 2)
    //   return false
    return true;
  }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.feesIncreaselist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }

  cancel() {
    this.router.navigate(['/schoolfeesincreaserequestlist']);
  }
}
